import { render, staticRenderFns } from "./recurring-transfers-grid.vue?vue&type=template&id=71235016&"
import script from "./recurring-transfers-grid.ts?vue&type=script&lang=js&"
export * from "./recurring-transfers-grid.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports